'use strict';
import axios from 'axios';
import { getAuthItem } from '../auth/authStorage';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.integranube.cl',
  timeout: 20000,
  headers: { Accept: 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = getAuthItem('token');
  const tenantid = getAuthItem('tenantid');
  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (tenantid) {
    config.headers.tenantid = tenantid;
    config.headers.tenantId = tenantid;
  }
  return config;
});

export default api;
